import { Component, inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VisitDetailPhotos } from '@types-lib'


@Component({
    selector: 'delete-photo-dialog',
    imports: [],
    templateUrl: './delete-photo-dialog.component.html',
    styleUrl: './delete-photo-dialog.component.css'
})
export class DeletePhotoDialogComponent {
	dialogRef = inject<MatDialogRef<DeletePhotoDialogComponent>>(MatDialogRef);
	data = inject(MAT_DIALOG_DATA);


	getPhotoLabel(file:VisitDetailPhotos.Photo) {
		switch(file.id) {
			case 12:
				return 'Selfie Photo';
			default:
				return '';
		}
	}

	shouldDeletePhoto(approve = false) {
		this.dialogRef.close({ approve });
	}
}
